import { Typography } from '@mui/material'
import { useTexts } from './useTexts'

export function ErrorFetchingData() {
  const texts = useTexts()
  return <Typography>{texts.errorWhileFetchingData}</Typography>
}
